const urlService = {
  relativeToAbsolutePath: (submissionURL: string) => {
    const {
      location: { protocol, host },
    } = window;

    try {
      return new URL('', submissionURL).href;
    } catch {
      if (submissionURL.indexOf('/') === 0) {
        return new URL(submissionURL.replace('/', ''), `${protocol}//${host}/`).href;
      }

      return new URL(submissionURL, `${protocol}//${host}/`).href;
    }
  },
};

export default urlService;
